import axios from 'axios';
import { ensureProtocol } from '../config/backend';

function getBase() {
  return ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token } : {};
}

export async function fetchNotificacoes() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/notificacoes', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar notificações:', err);
    return [];
  }
}

export async function fetchNotificacoesNaoLidasCount() {
  const base = getBase();
  if (!base) return 0;
  try {
    const res = await axios.get(base + '/notificacoes/nao-lidas/count', { headers: getAuthHeaders(), timeout: 8000 });
    return res?.data?.count ?? 0;
  } catch (err) {
    return 0;
  }
}

export async function marcarComoLida(id) {
  const base = getBase();
  if (!base || !id) return;
  try {
    await axios.put(base + '/notificacoes/' + id + '/lida', {}, { headers: getAuthHeaders() });
  } catch (err) {
    console.error('Erro ao marcar notificação como lida:', err);
  }
}

export async function deletarNotificacao(id) {
  const base = getBase();
  if (!base || !id) return;
  try {
    await axios.delete(base + '/notificacoes/' + id, { headers: getAuthHeaders() });
  } catch (err) {
    console.error('Erro ao excluir notificação:', err);
    throw err;
  }
}

export async function deletarTodasNotificacoes() {
  const base = getBase();
  if (!base) return;
  try {
    await axios.delete(base + '/notificacoes', { headers: getAuthHeaders() });
  } catch (err) {
    console.error('Erro ao excluir todas as notificações:', err);
    throw err;
  }
}
